export default "__VITE_ASSET__51e8030b__"